/**
 * useThemeSync Hook
 * Synchronizes canvas theme with application theme
 */

import { useEffect } from 'react'
import { dia } from '@joint/core'

export function useThemeSync(paper: dia.Paper | null, theme: 'light' | 'dark') {
  useEffect(() => {
    if (!paper) return

    // Use setTimeout to ensure the DOM has been updated by ThemeProvider
    setTimeout(() => {
      const style = getComputedStyle(document.documentElement)
      const bgColor = style.getPropertyValue('--color-canvas-bg').trim()

      // Update background color
      const paperAny = paper as any
      if (paperAny.drawBackground) {
        paperAny.drawBackground({ color: bgColor })
      }

      // Note: Grid is disabled in useJointJSCanvas (drawGrid: false)
      // so we don't try to set grid here
    }, 0)
  }, [paper, theme])
}
